import React, { useState } from 'react';
import { User, Key, LogOut, ChevronDown } from 'lucide-react';
import { useAuth } from '@contexts/AuthContext';
import { PasswordChangeModal } from '@organisms/auth/PasswordChangeModal';

interface UserMenuProps {
  className?: string;
}

export const UserMenu: React.FC<UserMenuProps> = ({ className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const { user, logout } = useAuth();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    logout();
    setIsOpen(false);
  };

  const handlePasswordChange = () => {
    setIsPasswordModalOpen(true);
    setIsOpen(false);
  };

  const handlePasswordChangeSuccess = (_newToken: string) => {
    setIsPasswordModalOpen(false);
  };

  return (
    <div className={`relative ${className}`}>
      {/* User Menu Trigger */}
      <button
        onClick={toggleMenu}
        className="flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium text-white hover:text-accent-200 hover:bg-primary-600 transition-all duration-200"
      >
        <User className="w-4 h-4" />
        <span>{user?.name || user?.email}</span>
        <ChevronDown 
          className={`w-4 h-4 ml-1 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
          <div className="py-1">
            {/* Change Password Option */}
            <button
              onClick={handlePasswordChange}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <Key className="w-4 h-4 mr-2" />
              Change Password
            </button>

            {/* Logout Option */}
            <button
              onClick={handleLogout}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </button>
          </div>
        </div>
      )}

      {/* Password Change Modal */}
      <PasswordChangeModal
        isOpen={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
        onSuccess={handlePasswordChangeSuccess}
      />
    </div>
  );
};
